import { createSlice } from '@reduxjs/toolkit';

import { toggleButtonGroupValues } from './constants';

const initialState = {
	availableLeads: [],
	toggleValue: toggleButtonGroupValues.TAKEN,
	takenOrInProgressLeads: [],
};

export const dashboardMarketPlace = createSlice({
	name: 'dashboard-marketPlace',
	initialState,
	reducers: {
		setAvailableLeads: (state, { payload }) => ({
			...state,
			availableLeads: payload,
		}),
		setTakenOrInProgressLeads: (state, { payload }) => ({
			...state,
			takenOrInProgressLeads: payload,
		}),
		setToggleValue: (state, { payload }) => ({
			...state,
			toggleValue: payload,
		}),
		reset: () => initialState,
	},
});

export default dashboardMarketPlace.reducer;
export const REDUCER_NAME = dashboardMarketPlace.name;

export const { setAvailableLeads, setTakenOrInProgressLeads, setToggleValue, reset } = dashboardMarketPlace.actions;
